import type { SelectedFile } from '@witmetrics/utils';
import type { TimelineItemType } from '@witmetrics/unison-core';
import { asyncMap } from '@witmetrics/utils/arrays';
import { API } from '@/api';
import { uploadNoteAttachment } from '@/utils/files';
import { useLocalStorage } from '@/hooks/useStorage';
import type { NewKeypointData } from './types';

export const classes = {
  column:
    'flex flex-col h-full min-h-0 bg-[linear-gradient(180deg,transparent_0%,rgba(241,90,43,0.06)_16%,transparent_64%)]',
  titleBlock: 'place-between gap-[10px] mb-4 shrink-0 px-5 pt-5',
  title: 'font-bold text-base text-taupe-3 dark:text-mauve-1',
  controls: 'flex items-center gap-[10px]',
  message: 'mt-4 text-center text-taupe-1 dark:text-mauve-3',
  timeline: 'flex-1 min-h-0 overflow-y-auto px-5 pb-5',
  fieldWrapper: 'px-5',
  field: 'border border-grey-3 dark:border-white/10',
};

export function useTimelineSettings(initialSettings?: TimelineItemType) {
  return useLocalStorage('timelineSettings', initialSettings || 'ALL', true);
}

export async function createProjectNote(
  projectId: number,
  content: string,
  selectedFiles: SelectedFile[]
) {
  const note = await API.Notes.createNewNote({ content });
  const [attachments, projectNote] = await Promise.all([
    uploadAttachmentFiles(note.id, selectedFiles),
    API.UnisonProjects.addNoteToUnisonProject(projectId, note.id),
  ]);
  return {
    projectNote,
    attachments,
  };
}

function uploadAttachmentFiles(noteId: number, files: SelectedFile[]) {
  return asyncMap(files, async (selectedFile) => {
    const noteFile = await uploadNoteAttachment(noteId, selectedFile.file);
    return { noteFile, selectedFile };
  });
}

export async function createProjectKeypoint({
  projectId,
  practiceId,
  keypointTypeId,
  startsAt,
  message,
}: NewKeypointData) {
  const keypoint = await API.Keypoints.createNewKeypoint({
    practiceId,
    keypointTypeId,
    content: { message },
    startsAt,
  });
  return API.UnisonProjects.addKeypointToUnisonProject(projectId, keypoint.id);
}
